import { RowProps } from 'antd';
import { StyledRow } from './index.styles';

export function Row(props: RowProps) {
  return <StyledRow gutter={[16, 16]} {...props} />;
}
